import React, { useState } from "react";
import {
  Typography,
  Box,
  IconButton,
  Avatar,
  AppBar,
  Toolbar,
  Tabs,
  Tab,
} from "@mui/material";
import { Notifications, CalendarToday } from "@mui/icons-material";
import AppHeaderBar from "../../components/AppBar/appBar";
import NotificationSettings from "./NotificationSettings";
import CompanyTiming from "./CompanyTiming";
import AdminRole from "./AdminRole";
import AdminUserManagement from "./AdminUserManagement";
import AdminStatus from "./AdminStatus";
import AdminComplaints from "./AdminComplaints";
import AdminSiteSettings from "./AdminSiteSettings";
import AdminPushnotification from "./AdminPushnotification";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const AdminSettings = ({ onBackScreenName }) => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleScreeName = (sname) => {
    onBackScreenName(sname);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "#EEF2FF",
          p: 3,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          // Hide scrollbar
          "&::-webkit-scrollbar": {
            display: "none", // For Chrome, Safari, and Edge
          },
          msOverflowStyle: "none", // For Internet Explorer and Edge
          scrollbarWidth: "none", // For Firefox
        }}
      >
        {/* <AppBar
          position="static"
          elevation={0}
          sx={{
            borderBottom: "1px solid #ddd",
            mb: 2,
            backgroundColor: "white",
            color: "black",
            borderRadius: "20px",
          }}
        >
          <Toolbar>
            <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
              Settings & Configuration
            </Typography>
            <IconButton>
              <CalendarToday />
            </IconButton>
            <Typography variant="body1" sx={{ mx: 2 }}>
              28 July, 2024
            </Typography>
            <IconButton>
              <Notifications />
            </IconButton>
            <Avatar alt="Gn" src="/profile.webp" />
          </Toolbar>
        </AppBar> */}

        <AppHeaderBar
          title={"Settings & Configuration"}
          onBackScreenName={handleScreeName}
        />

        <Tabs value={value} onChange={handleChange} aria-label="settings tabs">
          <Tab label="Notification" />
          <Tab label="Timings" />
          <Tab label="Roles" />
          <Tab label="Users" />
          <Tab label="Status" />
          <Tab label="Complaints" />
          <Tab label="Site Settings" />
          <Tab label="Push Notifications" />
        </Tabs>

        <TabPanel value={value} index={0}>
          <NotificationSettings />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <CompanyTiming />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <AdminRole />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <AdminUserManagement />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <AdminStatus />
        </TabPanel>
        <TabPanel value={value} index={5}>
          <AdminComplaints />
        </TabPanel>
        <TabPanel value={value} index={6}>
          <AdminSiteSettings />
        </TabPanel>
        <TabPanel value={value} index={7}>
          <AdminPushnotification />
        </TabPanel>
      </Box>
    </Box>
  );
};

export default AdminSettings;
